import { useMutation, useQueryClient } from "@tanstack/react-query";
import collectionApiClient, { DateValue } from "../../../api/collection";
import refetchCollectionQueries from "../utils/refetchCollectionQueries";

const usePublishCollectionToShopifyMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["publish-collection-to-shopify"],
    mutationFn: ({
      collectionId,
      date,
    }: {
      collectionId: string;
      date?: DateValue;
    }) => {
      return collectionApiClient.publishCollectionToShopify(collectionId, date);
    },
    onSettled: () => refetchCollectionQueries(queryClient),
  });
};

export default usePublishCollectionToShopifyMutation;
